import flatpickr from 'flatpickr';

// Init date picker on Form assembly forms 
export default(() => {
    const datePickers = Array.from(document.querySelectorAll('.validate-datecal'));

    datePickers.forEach((picker) => {
        flatpickr(picker, {
            dateFormat: 'd/n/Y',
            allowInput: true,
            minDate: picker.classList.contains('calc-FutureDate') ? 'today' : undefined
        });
    });

})()

